import { render, staticRenderFns } from "./CRUDy.vue?vue&type=template&id=d9bf6f24&scoped=true&"
import script from "./CRUDy.vue?vue&type=script&lang=js&"
export * from "./CRUDy.vue?vue&type=script&lang=js&"
import style0 from "./CRUDy.vue?vue&type=style&index=0&id=d9bf6f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bf6f24",
  null
  
)

export default component.exports